import {
  GET_OPPORTUNITIES,
  GET_INFORMATION,
  SET_CARD,
} from "./types";
import axios from "axios";
import { refreshToken } from "../../store/actions/authActions";
import {
  getTokenFromCookie,
  checkTokenExpiration,
} from "../../utils/getCookies";


export const getOpportunities =
  () =>
  async (dispatch, getState, { getFirestore }) => {
    try {
      if (!checkTokenExpiration()) {
        await refreshToken(getTokenFromCookie());
      }
      const response = await axios.get(
        `${process.env.REACT_APP_GOLANG_API}/staking-opportunities`,
      );
      dispatch({
        type: GET_OPPORTUNITIES,
        payload: {
          opportunities: response.data.opportunities,
          averageYieldPercentage: response.data.averageYieldPercentage,
        },
      });
    } catch (error) {
      return error;
    }
  };

export const getInformation =
  () =>
  async (dispatch, getState, { getFirestore }) => {
    try {
      if (!checkTokenExpiration()) {
        await refreshToken(getTokenFromCookie());
      }
      const response = await axios.get(
        `${process.env.REACT_APP_GOLANG_API}/staking-information`,
      );
      dispatch({
        type: GET_INFORMATION,
        payload: response.data.information,
      });
    } catch (error) {
      return error;
    }
  };

export const setSelectedCard = (card) => {
  return (dispatch) => {
    dispatch({
      type: SET_CARD,
      payload: card,
    });
  };
};
